// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.message.LeasingMessageWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetLastMessageWebApiResponseDto } from '../..';

interface GetLastMessageParams {
  leaseId: number;
}

export const LeasingMessageWebApiHandler_getLastMessage_Path = '/api/web/v1/message/getLastMessage';

/**
 * get most recent lease message
 */
export const LeasingMessageWebApiHandler_getLastMessage = (getParams: GetLastMessageParams, client = getClient()) => {
  return httpFrontEndRequest<GetLastMessageParams, never, GetLastMessageWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingMessageWebApiHandler_getLastMessage_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
